import * as yup from 'yup';

export const ReassignCostCenterSchema = yup.object().shape({
    reassignedOrg: yup
        .string()
        .ensure()
        .required('Org is required')
});
